import { TEpDevPEntityId } from './EpDevPEntityIdsServiceTypes';
import { EEpDevPAssetStateFilter } from './EpDevPAssetTypes';
import { EpDevPPluginIds } from '../constants';

export enum EpDevPSearchPageAssetFilters {
  Domains = 'domains',
  State = 'state',
  BrokerType = 'brokerType',
  Environments = 'environments',
}

export interface IEpDevPBackstageAppConfig {
  title: string;
  // include if needed
  // support: SupportConfig;
}
export interface IEpDevPBackstageBackendConfig {
  baseUrl: string;
}
export interface IEpDevPBackstageGitlabConfig {
  projectId: string;
  privateToken: string;
  repoUrl: string;
  branchName: string;
  globalMdFilePath: string;
  projectPath: string;
  jsonFilePath: string;
}

export interface IEpDevPBackstageConfig {
  app: IEpDevPBackstageAppConfig;
  backend: IEpDevPBackstageBackendConfig;
  gitlab: IEpDevPBackstageGitlabConfig;
}
export interface IEpDevPConfigOrganizationSettings {
  epKafkaTopicDelimiter: string;
}
export interface IEpDevPConfigEpService {
  cloudToken: string;
  apiBaseUrl: string;
}
export interface IEpDevPConfigOrganization {
  entityId: TEpDevPEntityId;
  epConsoleBaseUrl: string;
  epCoreService: IEpDevPConfigEpService;
  epApimService: IEpDevPConfigEpService;
  settings: IEpDevPConfigOrganizationSettings;
}
export interface IEpDevPConfigAuthClaims {
  userId: string;
  firstName: string;
  lastName: string;
  email: string;  
}
export interface IEpDevPConfigAuth {
  claims: IEpDevPConfigAuthClaims;
}
export interface IEpDevPConfigSearchPage {
  assetFilters: Array<EpDevPSearchPageAssetFilters>;
}
export interface IEpDevPConfigSearch {
  multiTenancy: boolean;
  searchPage: IEpDevPConfigSearchPage;
}
export interface IEpDevPConfigSmtp {
  hostname: string;
  port: number;
  username: string;
  password: string;
  logger: boolean;
}
export interface IEpDevPConfigSupportEmail {
  from: string;
  to: Array<string>;
  replyTo: string;
}
export interface IEpDevPConfigSupportLink {
  title: string;
  url: string;
  description: string;
}
export interface IEpDevPConfigSupport {
  email: IEpDevPConfigSupportEmail;
  link: IEpDevPConfigSupportLink;
}
export interface IEpDevPConfigLogging {
  logDir?: string;
  epSdkLogLevel: string;
  epApiReqResLogging: boolean;
}
export interface IEpDevPConfigImporterPublishDestination {
  attributeName: string;
  attributeValue: string;
}
export interface IEpDevPConfigImporterSchedule {
  frequency: {
    minutes: number;
  },
  timeout: {
    minutes: number;
  }
}
export interface IEpDevPConfigEventPortalCustomTags {
  customAttributePrefix: string;
}
export interface IEpDevPConfigEventPortal {
  epCustomTags: IEpDevPConfigEventPortalCustomTags;
}
export interface IEpDevPConfigImporter {
  epPublishDestination: IEpDevPConfigImporterPublishDestination;
}
export interface IEpDevPConfigImporterRules {
  setEpAttributes: boolean;
  assetStateFilter: EEpDevPAssetStateFilter;
}
export interface IEpDevPConfigPluginImporter {
  schedule: IEpDevPConfigImporterSchedule;
  rules: IEpDevPConfigImporterRules;
}
export enum EpDevPEpServiceTypes {
  EpCoreService = "ep-core-service",
  EpApimService = "ep-apim-service"
}
export interface IEpDevPConfigPluginAppsRegistrationDestination {
  attributeName: string;
  attributeValue: string;
}
export interface IEpDevPConfigPluginConsumerAppsRegistrationDestination extends IEpDevPConfigPluginAppsRegistrationDestination {};
export interface IEpDevPConfigPluginCredentials {
  allowManage: boolean;
}
export interface IEpDevPConfigPlugin {
  epService: EpDevPEpServiceTypes;
  importer: IEpDevPConfigPluginImporter;
  epApplicationRegistrationDestination?: IEpDevPConfigPluginConsumerAppsRegistrationDestination;
  epCredentialsConfig?: IEpDevPConfigPluginCredentials;
}
export enum EpDevPConfigDeploymentOptions {
  APIM_MARKETPLACE = "apim-marketplace",
  APIM_CONSOLE = "apim-console",
  EVENT_PORTAL_DISCOVERY = "event-portal-discovery",
}
export interface IEpDevPConfigConsoleManagedDeveloperPortal {
  systemId: string;
}
export interface IEpDevPConfigConsole {
  managedDeveloperPortals: Array<IEpDevPConfigConsoleManagedDeveloperPortal>;
}
export interface IEpDevPConfigSystemEvents {
  useBroker: boolean;
  brokerProtocol: "mqtt";
  brokerHost: string;
  brokerPort: number;
  brokerUsername: string;
  brokerPassword: string;
}
export interface IEpDevPConfig {
  backstage: IEpDevPBackstageConfig;
  systemId: string;
  auth: IEpDevPConfigAuth;
  search: IEpDevPConfigSearch;
  smtp: IEpDevPConfigSmtp;
  support: IEpDevPConfigSupport;
  logging: IEpDevPConfigLogging;
  importer: IEpDevPConfigImporter;
  eventPortal: IEpDevPConfigEventPortal;
  plugins: Record<EpDevPPluginIds, IEpDevPConfigPlugin>;
  uiDebugFlag: boolean;
  deployments: Array<EpDevPConfigDeploymentOptions>;
  organizations: Array<IEpDevPConfigOrganization>;
  console?: IEpDevPConfigConsole;
  systemEvents: IEpDevPConfigSystemEvents;
}

